{
  "confirm": "Confirm",
  "back": "Back",
  "error": {
    "generalError": "Something went wrong, please try again later or contact us."
  },
  "member": "one member | {count} members",
  "next": "Next",
  "roles": {
    "member": {
      "title": "Member",
      "description": "Regular members of this team"
    },
    "coach": {
      "title": "Coach",
      "description": "Coaches for your team's trainings"
    },
    "admin": {
      "title": "Admin",
      "description": "Users with admin privileges"
    }
  },
  "send": "Send",
  "submit": "Submit",
  "you": "You"
}
